import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { verifyUser } from '../redux/actions/auth'
import { getUserbrands } from '../redux/actions/brands'
import { IRootState } from '../redux/types'

const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch()
  const { userBrands } = useSelector((state: IRootState) => state.brand)

  useEffect(() => {
    if (localStorage.getItem('isAuth') !== null) {
      dispatch(verifyUser())

      if (userBrands.length === 0) dispatch(getUserbrands())
    }
  }, [])

  return <>{children}</>
}

export default PublicRoute
